import { AnyObj } from '../moduleRouter/types';
import {
  Fiber, isToolsCanUse, workLoop, getInstanceFromNode,
  ClassComponentTag, ForwardRefTag, FunctionComponentTag, HostComponentTag, HostTextTag,
} from './reactTools';

// 记录重复的weId
let duplicatedWeIdMap: AnyObj = {};

// 排除特殊的 fiber 节点
function filterSpecialFiber (fiberNode: any) {
  if (!fiberNode.type) return true;
  return (
    [FunctionComponentTag, ClassComponentTag, HostComponentTag, HostTextTag, ForwardRefTag].includes(fiberNode.tag) &&
      (
        (fiberNode.type.displayName && fiberNode.type.displayName?.indexOf('withRouter(') !== -1) ||  // withRouter
        fiberNode.type.displayName === 'Router' || // Router
        (fiberNode.type.displayName && fiberNode.type.displayName.match(/^inject-with-/)) || // @inject
        fiberNode.type.displayName === 'MobXProvider' // MobxProvider
      )
  );
}

// 获取fiber节点信息
function getFiberInfo (fiberNode: Fiber) {
  const fiberInfo: AnyObj = {
    fiberTag: fiberNode.tag,
  };
  // 记录 type 信息
  if (fiberNode.type?.displayName) {
    fiberInfo.displayName = fiberNode.type?.displayName;
  }
  if (typeof fiberNode.type === 'string') {
    fiberInfo.type = fiberNode.type;
  } else if (typeof fiberNode.type === 'object' && typeof fiberNode.type.render === 'function') {
  } else if (typeof fiberNode.type === 'function') {
  }
  // 记录 props 信息
  if (fiberNode.memoizedProps) {
    fiberInfo.propKeys = Object.keys(fiberNode.memoizedProps);
    if (fiberNode.memoizedProps?.className) {
      fiberInfo.className = fiberNode.memoizedProps?.className;
    }
  }
  return fiberInfo;
}

// fiber 节点处理
function generateFiberHandler (pruning?: boolean) {
  return function (fiberNode: Fiber) {
    if (!fiberNode) return null;
    if (filterSpecialFiber(fiberNode)) return fiberNode.child;
    if (fiberNode && fiberNode.memoizedProps && fiberNode.memoizedProps.weId) {
      const weId = fiberNode.memoizedProps.weId;
      duplicatedWeIdMap[weId] = duplicatedWeIdMap[weId] || [];
      duplicatedWeIdMap[weId].push(getFiberInfo(fiberNode));
      if (pruning) {
        return null; // 如果父级的 weId已经重复，就没必要检查下级的 weId
      }
    }
    return fiberNode.child;
  }
}

export default function checkWeId (dom: Node, pruning?: boolean) {
  duplicatedWeIdMap = {};
  if (!isToolsCanUse) return null;
  const fiberRoot = getInstanceFromNode(dom);
  if (!fiberRoot) return null;
  workLoop(fiberRoot, generateFiberHandler(pruning));
  const duplicatedWeIds: AnyObj = {};
  Object.keys(duplicatedWeIdMap).forEach(weId => {
    const duplicatedNode = duplicatedWeIdMap[weId];
    // 筛选出存在重复weId的节点
    if (duplicatedNode?.length > 1) {
      duplicatedWeIds[weId] = duplicatedNode;
    }
  });
  duplicatedWeIdMap = {};
  return duplicatedWeIds;
}
